/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatientAllergies from '../reducer/patient-allergy.reducer';

export const patientAllergiesFeatureSelector = createFeatureSelector<fromPatientAllergies.PatientAllergiesState>(
  fromPatientAllergies.patientAllergiesFeatureKey
);

const { selectEntities, selectAll } = fromPatientAllergies.patientAllergiesAdapter.getSelectors();

export const selectPatientAllergyEntities = createSelector(patientAllergiesFeatureSelector, selectEntities);

export const selectPatientAllergies = createSelector(patientAllergiesFeatureSelector, selectAll);

export const selectCurrentCount = createSelector(
  selectPatientAllergies,
  patientAllergies => patientAllergies?.length ?? 0
);

export const selectError = createSelector(patientAllergiesFeatureSelector, state => state.baseState.error);

export const selectIsLoading = createSelector(patientAllergiesFeatureSelector, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(patientAllergiesFeatureSelector, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(patientAllergiesFeatureSelector, state => state.pageSize);

export const selectIsAtEndOfData = createSelector(
  patientAllergiesFeatureSelector,
  state => state.baseState.isAtEndOfData
);

export const selectTotalRecordCount = createSelector(
  patientAllergiesFeatureSelector,
  state => state.baseState.totalRecordCount ?? 0
);

export const selectIsFullDatasetLoaded = createSelector(
  patientAllergiesFeatureSelector,
  state => state?.isFullDatasetLoaded ?? false
);

export const selectCachePatientId = createSelector(
  patientAllergiesFeatureSelector,
  state => state?.cachePatientId ?? null
);

export const selectCacheLoadedAt = createSelector(
  patientAllergiesFeatureSelector,
  state => state?.cacheLoadedAt ?? null
);

export const selectIsFullDatasetLoading = createSelector(
  patientAllergiesFeatureSelector,
  state => state?.isFullDatasetLoading ?? false
);

export const selectFullDatasetError = createSelector(
  patientAllergiesFeatureSelector,
  state => state?.fullDatasetError ?? null
);
